import React from 'react';
import { getPreLoanRequestEligibility } from '../queries/preloan';

export type EligibilityValue = {
  eligible: boolean;
  plrStep?: string;
  loading: boolean;
};

const INITIAL: EligibilityValue = {
  eligible: false,
  plrStep: undefined,
  loading: true,
};

const EligibilityContext = React.createContext<EligibilityValue>(INITIAL);

export type EligibilityProviderProps = {
  token: string;
  children: React.ReactNode;
};

export function EligibilityProvider(props: EligibilityProviderProps) {
  const { token, children } = props;
  const [value, setValue] = React.useState<EligibilityValue>(INITIAL);

  React.useEffect(() => {
    if (!token) {
      setValue({ ...INITIAL, loading: false });
      return undefined;
    }
    let cancelled = false;
    setValue(INITIAL);
    getPreLoanRequestEligibility(token)
      .then((res) => {
        if (cancelled) return;
        setValue({
          eligible: res.data.eligible,
          plrStep: res.data.plrStep,
          loading: false,
        });
      })
      .catch(() => {
        if (cancelled) return;
        setValue({ ...INITIAL, loading: false });
      });
    return () => { cancelled = true; };
  }, [token]);

  return (
    <EligibilityContext.Provider value={value}>
      {children}
    </EligibilityContext.Provider>
  );
}

export function useEligibility() {
  return React.useContext(EligibilityContext);
}

export default EligibilityContext;
